export default __webpack_public_path__ + "static/media/img-ltsh-3-left-mobile.105b913b.png";